import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 停止するとタレントはログインすることができなくなります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 本当に停止してよろしいですか？ ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("停止")


  import { useUserSuspendDialog } from '@/logic/users/UserSuspendDialogLogic'

  interface Props {
    modelValue: boolean;
    user: {id: number};
  }
  interface Emits {
    (e: 'submit'): void;
    (e: 'update:model-value', value: boolean): void;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: true },
    user: { type: Object, required: true }
  },
  emits: ["submit", "update:model-value"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'submit'): void;
    (e: 'update:model-value', value: boolean): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: boolean;
    user: {id: number};
  }
  

  

  const {
    form,
    handleSubmit: _handleSubmit,
  } = useUserSuspendDialog();

  const handleSubmit = async () => {
    await _handleSubmit();

    emit('submit');
  }

  const handleOpen = () => {
    form.id = props.user.id;

    emit('update:model-value', true);
  };

  const handleClose = () => {
    form.id = null;

    emit('update:model-value', false);
  }

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    onOpen: handleOpen,
    onClose: handleClose,
    title: "停止確認",
    width: "30%"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})